import _ from 'lodash';

const { snakeCase } = _;

export const formatToolName = (name: string) => {
  //snake_case and replace / with _ and remove spaces
  return snakeCase(name.replace(/ /g, '_'));
};
